export default {
    SAVE: "Сохранить",
    CANCEL: "Отменить",
    NAME: "Название"
};
